import { useState, useEffect } from "react";

import { UserAPI } from "API/userApi";
import { IPerson } from "interfaces/intarfaces";
import { ERROR_404, ERROR_ANY } from "utils/constants";
import { generateErrorResponse } from "../helpers";

export const useFetchUser = (id: string | undefined) => {
  const [data, setData] = useState<IPerson | undefined>(undefined);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string>("");

  useEffect(() => {
    if (id) {
      setLoading(true);
      setError("");

      UserAPI.getUser(id, { showNotificationOnError: false })
        .then((response) => {
          setData(response as IPerson);
        })
        .catch((error) => {
          setData(undefined);
          const response = generateErrorResponse(error);
          if (response.status === 404) {
            setError(ERROR_404);
          } else {
            setError(ERROR_ANY);
          }
        })
        .finally(() => setLoading(false));
    } else {
      setData(undefined);
    }
  }, [id]);

  return { data, loading, error };
};
